import { Card, Table, Input, Col, DatePicker, Row, Select, Slider, Typography, Button, Divider, Tag, Pagination, message, Spin } from "antd";
import { withRouter } from "react-router-dom";
import React, { Component } from "react";
import { connect } from "react-redux";
import { debounce } from "lodash";

import DashboardLayout from "../../layout/dashboardLayout/DashboardLayout";
import ArDetail from "./ArDetail";

import { dashboardActions } from "../../actions";
import { controller } from "../../controller";
import "../app.local.css";
import "./style.css";

import calendar from "../../assets/icons/calendar.png";
import arrow from "../../assets/icons/arrow-left.png";
import card from "../../assets/icons/card-tick.png";
import filter from "../../assets/icons/filter.png";
// import { error } from "pdf-lib";

const { Option } = Select;
const { Title } = Typography;
const dateFormat = "YYYY/MM/DD";

class AR extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showContent: false,
    };

    this.state = {
      selectedFilters: [],
    };

    this.state = {
      searchPatientTerm: "",
      isGettingGuarantors: false,
      providers: [],
      entryId: "",
      currentPage: 1,
      maxAr: 0,
      loading: true,
      dueDate: "",
      serverLogo: "",
      ARList: [],
      Guarantor: [],
      Practice: [],
      selectedProvider: null,
      selectedGuarantor: null,
      selectedPractice: null,
      selectedStartDate: null,
      selectedEndDate: null,
      min_date: null,
      max_date: null,
      entry_id: null,
      min_amount: null,
      max_amount: null,
      page_size: 1,
      page: 1,
      search_term: "",
      mainloading: false,
      selectedAR: null,
      selectedDueDate: [],
      cardData: {
        total_0_30: 0,
        total_31_60: 0,
        total_61_90: 0,
        total_greater_than_90: 0,
      },
    };
    this.getCardData();
    this.getLogo();
    this.getData();
    this.getProviders();
    this.getLogo = this.getLogo.bind(this);
    this.getData = this.getData.bind(this);
    this.handleSearchGuarantor = this.handleSearchGuarantor.bind(this);
    this.updateGetAR = debounce(this.updateGetAR, 500);

    this.getProviders = this.getProviders.bind(this);
    this.handleChangeDueDate = this.handleChangeDueDate.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.updateSelectedFilters = this.updateSelectedFilters.bind(this);
    // this.removeFilter = this.removeFilter.bind(this);

    this.props.dispatch(dashboardActions.fetchProfileSummary());
    this.props.dispatch(dashboardActions.fetchSummary());
  }

  getProviders = async () => {
    const response = await controller.getProviderList();
    this.setState({ providers: response });
  };

  getCardData = async () => {
    const response = await controller.getCardData();
    this.setState({ cardData: response });
  };

  handlePageChange = async (page) => {
    this.setState({ currentPage: page, loading: true });

    const { selectedGuarantor, selectedPractice, selectedStartDate, selectedEndDate, entryId, min_amount, max_amount, selectedDueDate } = this.state;

    // Convert moment objects to YYYY-MM-DD format, or use null if not set
    const startDateStr = selectedStartDate ? selectedStartDate.format("YYYY-MM-DD") : null;
    const endDateStr = selectedEndDate ? selectedEndDate.format("YYYY-MM-DD") : null;
    const dueDateStr = selectedDueDate ? selectedDueDate.join(",") : "";

    try {
      this.setState({ loading: true });

      const response = await controller.updateGetAR2(
        selectedGuarantor,
        selectedPractice,
        startDateStr,
        endDateStr,
        entryId,
        min_amount,
        max_amount,
        dueDateStr,
        page
      );

      this.setState({
        page: page,
        page_size: response.count,
        ARList: response.results,
        loading: false,
      });
    } catch (error) {
      console.error("Error in handlePageChange:", error);
    } finally {
      this.setState({ loading: false });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    // Check for specific changes in state that should trigger the filter update
    if (
      prevState.selectedStartDate !== this.state.selectedStartDate ||
      prevState.selectedEndDate !== this.state.selectedEndDate ||
      prevState.selectedDueDates !== this.state.selectedDueDates ||
      prevState.selectedGuarantor !== this.state.selectedGuarantor ||
      prevState.entryId !== this.state.entryId ||
      prevState.selectedAmountRange !== this.state.selectedAmountRange
    ) {
      this.updateSelectedFilters();
    }
  }

  updateSelectedFilters = () => {
    const filters = [];
    if (this.state.selectedStartDate) {
      filters.push(`Start Date: ${this.state.selectedStartDate.format("YYYY/MM/DD")}`);
    }
    if (this.state.selectedEndDate) {
      filters.push(`End Date: ${this.state.selectedEndDate.format("YYYY/MM/DD")}`);
    }
    if (this.state.selectedDueDates && this.state.selectedDueDates.length > 0) {
      filters.push(`Overdue By: ${this.state.selectedDueDates.join(", ")}`);
    }
    if (this.state.selectedGuarantor) {
      filters.push(`Patient: ${this.state.selectedGuarantor}`);
    }
    if (this.state.entryId) {
      filters.push(`ID: ${this.state.entryId}`);
    }
    if (this.state.selectedAmountRange && this.state.selectedAmountRange.length === 2) {
      filters.push(`Amount Range: $${this.state.selectedAmountRange[0]} - $${this.state.selectedAmountRange[1]}`);
    }
    this.setState({ selectedFilters: filters });
  };

  updateGetAR = async () => {
    const { selectedStartDate, selectedEndDate, selectedProvider, selectedGuarantor, selectedPractice, entryId, min_amount, max_amount } = this.state;

    const startDateStr = selectedStartDate ? selectedStartDate.format("YYYY-MM-DD") : "";
    const endDateStr = selectedEndDate ? selectedEndDate.format("YYYY-MM-DD") : "";

    try {
      this.setState({ loading: true });

      const response = await controller.updateGetAR(
        selectedProvider,
        selectedGuarantor,
        selectedPractice,
        startDateStr,
        endDateStr,
        entryId,
        min_amount,
        max_amount
      );
      this.setState({
        page: 1,
        currentPage: 1,
        page_size: response.count,
        ARList: response.results,
      });
    } catch (err) {
      message.error("Something went wrong while updating AR");
      console.error(err);
    } finally {
      this.setState({ loading: false });
    }
  };

  handleChangeDueDate = async (value) => {
    const dueDateStr = value.join(",");

    const { selectedGuarantor, selectedPractice, selectedStartDate, selectedEndDate, entryId, min_amount, max_amount } = this.state;

    // Convert moment objects to YYYY-MM-DD format, or use null if not set
    const startDateStr = selectedStartDate ? selectedStartDate.format("YYYY-MM-DD") : null;
    const endDateStr = selectedEndDate ? selectedEndDate.format("YYYY-MM-DD") : null;

    try {
      this.setState({ loading: true });
      const response = await controller.updateGetAR2(
        selectedGuarantor,
        selectedPractice,
        startDateStr,
        endDateStr,
        entryId,
        min_amount,
        max_amount,
        dueDateStr,
        1
      );
      this.setState(
        {
          page: 1,
          currentPage: 1,
          page_size: response.count,
          ARList: response.results,
          selectedDueDate: value,
        },
        () => {
          this.updateSelectedFilters();
        }
      );
    } catch (error) {
      console.error("Error in handleChangeDueDate:", error);
      this.setState({ loading: false });
    } finally {
      this.setState({ loading: false });
    }
  };

  handleSearchGuarantor = async (value) => {
    const responsegetGuarantor = await controller.searchGuarantor(value);
    this.setState({ Guarantor: responsegetGuarantor });
  };

  handleStartDateChange = (date, dateString, value) => {
    this.setState({ selectedStartDate: date }, () => {
      this.updateSelectedFilters();
      setTimeout(() => {
        this.updateGetAR();
      }, 500);
    });
  };

  handleEndDateChange = (date, dateString, value) => {
    this.setState({ selectedEndDate: date }, () => {
      this.updateSelectedFilters();
      setTimeout(() => {
        this.updateGetAR();
      }, 500);
    });
  };

  getGuarantors = async (search) => {
    try {
      this.setState({ isGettingGuarantors: true });

      const response = await controller.getGuarantor(search);

      console.log(response);
      this.setState({ Guarantor: response });
    } catch (err) {
      message.error("Something went wrong while getting guarantors");
      console.error(err);
    } finally {
      this.setState({ isGettingGuarantors: false });
    }
  };

  getData = async () => {
    try {
      this.setState({ loading: true });
      const response = await controller.getAR(this.state.currentPage);
      // const responsegetGuarantor = await controller.getGuarantor();
      const responsegetPracticeOffices = await controller.getPracticeOffices();
      const responseMaxAmountAR = await controller.getMaxAmountAR();
      this.setState({
        Practice: responsegetPracticeOffices.data,
        // Guarantor: responsegetGuarantor,
        page: 1,
        page_size: response.count,
        ARList: response.results,
        loading: false,
        maxAr: responseMaxAmountAR.max_value,
        max_amount: responseMaxAmountAR.max_value,
      });
    } catch (err) {
      message.error("Something went wrong while getting ar data");
      console.error(err);
    } finally {
      this.setState({ loading: false });
    }
  };

  toggleContent = () => {
    this.setState((prevState) => ({ showContent: !prevState.showContent }));
  };

  getLogo = async () => {
    const response = await controller.getLogo();
    this.setState({ serverLogo: response.data.dark });
  };

  handleBack = () => {
    this.setState({ selectedAR: null });
  };

  render() {
    // const { loadingSummary, loadingRequests, profileSummary } = this.props;
    const { profileSummary } = this.props;

    const datePickerStyle = { width: "90%", height: 42, border: "1px solid #6B43B5" };
    const selectStyle = { width: "90%", height: 42, border: "1px solid #6B43B5", borderRadius: "7px" };
    const inputStyle = { width: "90%", height: 42, border: "1px solid #6B43B5", borderRadius: "8px" };
    const sliderStyle = { width: "90%", height: 42, marginTop: 20 };

    // const className = "dashboard-container" + (loadingSummary || loadingRequests ? " is-loading" : "");
    const columns = [
      {
        title: "ID",
        dataIndex: "id",
        key: "id",
        sorter: (a, b) => a.id - b.id,
      },
      {
        title: "Patient",
        render: (_, record) => (
          <>
            {record ? (
              record.guarantor ? (
                <>
                  {record.guarantor.firstname} {record.guarantor.lastname}
                </>
              ) : (
                ""
              )
            ) : (
              ""
            )}
          </>
        ),
      },
      {
        title: "Total Amount",
        dataIndex: "total_amount",
        key: "total_amount",
        sorter: (a, b) => a.total_amount - b.total_amount,
        render: (text) => (!text.includes("$0.00") ? text : "-"),
      },
      {
        title: "AR (0-29 Days)",
        dataIndex: "amount_between_0_30",
        key: "amount_between_0_30",
        sorter: (a, b) => a.amount_between_0_30 - b.amount_between_0_30,
        render: (text) => (!text.includes("$0.00") ? text : "-"),
      },
      {
        title: "AR (30-59 Days)",
        dataIndex: "amount_between_31_60",
        key: "amount_between_31_60",
        sorter: (a, b) => a.amount_between_31_60 - b.amount_between_31_60,
        render: (text) => (!text.includes("$0.00") ? text : "-"),
      },
      {
        title: "AR (60-89 Days)",
        dataIndex: "amount_between_61_90",
        key: "amount_between_61_90",
        sorter: (a, b) => a.amount_between_61_90 - b.amount_between_61_90,
        render: (text) => (!text.includes("$0.00") ? text : "-"),
      },
      {
        title: "AR (+90)",
        dataIndex: "amount_greater_than_90",
        key: "amount_greater_than_90",
        sorter: (a, b) => a.amount_greater_than_90 - b.amount_greater_than_90,
        render: (text) => (!text.includes("$0.00") ? text : "-"),
      },
      {
        title: "Current Date",
        render: (_, record) => (
          <>
            {record ? (
              record.current_date ? (
                <>{new Date(record.current_date).toLocaleDateString() + " " + new Date(record.current_date).toLocaleTimeString()}</>
              ) : (
                ""
              )
            ) : (
              ""
            )}
          </>
        ),
      },
    ];

    if (this.state.selectedAR) {
      return <ArDetail handleBack={this.handleBack} />;
    }

    return (
      <DashboardLayout breadCrumb={"AR"} logo={profileSummary && profileSummary.logo ? profileSummary.logo : ""} footerLogo={this.state.serverLogo}>
        <div className="paymentRequestContent">
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: 25, width: "100%" }}>
            <Title level={4}>Accounts Receivable</Title>
            {!this.state.showContent && (
              <Button className="details-button-color1" type="text" onClick={this.toggleContent}>
                <span className="size-16" style={{ color: "black" }}>
                  Filters
                </span>
                <img src={filter} alt="" style={{ marginLeft: "8px" }} />
              </Button>
            )}
          </div>
          {this.state.showContent && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: 10,
                width: "100%",
                alignItems: "center",
              }}
            >
              <Title level={5}>Advanced Filters</Title>
              <Button className="details-button-color1" type="text" onClick={this.toggleContent}>
                <img src={filter} alt="" style={{ marginLeft: "8px", bottom: 5, position: "relative" }} />
              </Button>
            </div>
          )}
          <div className="selected-filters">
            {this.state.selectedFilters &&
              this.state.selectedFilters.map((filter, index) => (
                <>
                  <Tag
                    key={index}
                    style={{
                      height: 28,
                      background: "#EEEDFA",
                      borderRadius: "500px",
                      color: "#6B43B5",
                      padding: 3,
                      paddingLeft: 8,
                      paddingRight: 8,
                    }}
                  >
                    {filter}
                  </Tag>
                </>
              ))}
          </div>

          {this.state.showContent && (
            <>
              <Row gutter={[16, 16]} justify="space-between" type="flex" style={{ marginBottom: 23 }}>
                <Col xs={24} md={8}>
                  <Row>
                    <label>Start Date</label>
                  </Row>
                  <div className="c1">
                    <DatePicker
                      onChange={this.handleStartDateChange}
                      suffixIcon={<img src={calendar} alt="" />}
                      style={datePickerStyle}
                      format={dateFormat}
                      value={this.state.selectedStartDate}
                    />
                    <Divider type="vertical" className="vertical-divider2" />
                  </div>
                </Col>
                <Col xs={24} md={8}>
                  <Row>
                    <label>End Date</label>
                  </Row>
                  <DatePicker
                    onChange={this.handleEndDateChange}
                    suffixIcon={<img src={calendar} alt="" />}
                    style={datePickerStyle}
                    format={dateFormat}
                    value={this.state.selectedEndDate}
                  />
                  <Divider type="vertical" className="vertical-divider2" />
                </Col>
                <Col xs={24} md={8}>
                  <Row>
                    <label style={{ marginBottom: 15 }}>Overdue By</label>
                  </Row>
                  <Select
                    style={selectStyle}
                    id="due-date-select"
                    mode="multiple"
                    placeholder="Select due dates"
                    onChange={this.handleChangeDueDate}
                    suffixIcon={<img src={arrow} alt="" />}
                    value={this.state.selectedDueDate}
                  >
                    <Option value="amount_between_0_30">AR (0-29 Days)</Option>
                    <Option value="amount_between_31_60">AR (30-59 Days)</Option>
                    <Option value="amount_between_61_90">AR (60-89 Days)</Option>
                    <Option value="amount_greater_than_90">AR (+90 Days)</Option>
                  </Select>
                  <Divider type="vertical" className="vertical-divider21" />
                </Col>
                <Col span={24} style={{ display: "flex", flexDirection: "row", marginTop: 20, paddingLeft: 0 }}>
                  <Col xs={24} md={8}>
                    <Row>
                      <label>Patient</label>
                    </Row>
                    <Select
                      style={selectStyle}
                      placeholder="Patient"
                      suffixIcon={<img src={arrow} alt="" />}
                      value={this.state.selectedPatient || this.state.selectedGuarantor}
                      showSearch
                      allowClear
                      filterOption={(input, option) => {
                        if (!input) return true;
                        if (!option.children) return false;

                        const searchTerms = input
                          .toLowerCase()
                          .split(/\s+/)
                          .filter((term) => term); // Split input by whitespace and remove empty terms
                        const optionText = option.children.toLowerCase();

                        // Return true if all search terms are found in the option's text
                        return searchTerms.every((term) => optionText.includes(term));
                      }}
                      onClear={() => {
                        this.setState({ selectedGuarantor: "" });
                        setTimeout(() => {
                          this.updateGetAR();
                        }, 500);
                      }}
                      onChange={(e) => {
                        this.setState({ selectedGuarantor: e });
                        setTimeout(() => {
                          this.updateGetAR();
                        }, 500);
                        this.setState({ selectedPatient: e }, () => this.updateSelectedFilters());
                      }}
                      onSearch={debounce((search) => {
                        if (search) {
                          this.setState({ searchPatientTerm: search });
                          this.getGuarantors(search);
                        } else {
                          this.setState({ searchPatientTerm: "" });
                        }
                      }, 500)}
                    >
                      {this.state.searchPatientTerm.length > 0 ? (
                        this.state.Guarantor.length > 0 ? (
                          this.state.Guarantor.map((person) => (
                            <Option key={person.id} value={person.id}>
                              {`${person.firstname} ${person.middlename || ""} ${person.lastname}`}
                            </Option>
                          ))
                        ) : (
                          <Option key="empty" disabled>
                            Empty
                          </Option>
                        )
                      ) : (
                        <Option key="search-for-patient" disabled>
                          Search For Patient
                        </Option>
                      )}
                    </Select>

                    <Divider type="vertical" className="vertical-divider2" />
                  </Col>

                  <Col xs={24} md={8} style={{ paddingRight: 0 }}>
                    <Row>
                      <label>ID</label>
                    </Row>
                    <Input
                      style={inputStyle}
                      placeholder="Entry ID"
                      value={this.state.entryId}
                      onChange={(e) => {
                        this.setState({ entryId: e.target.value });
                        setTimeout(() => {
                          this.updateGetAR();
                        }, 500);
                      }}
                    />
                    <Divider type="vertical" className="vertical-divider2" />
                  </Col>

                  <Col xs={24} md={8} style={{ marginLeft: 7 }}>
                    <Row>
                      <label>Amount</label>
                    </Row>
                    <Slider
                      style={sliderStyle}
                      range
                      onChange={(e) => {
                        this.setState({ min_amount: e[0], max_amount: e[1] });
                        setTimeout(() => {
                          this.updateGetAR();
                          this.setState({ selectedAmountRange: e }, () => {
                            this.updateSelectedFilters();
                          });
                        }, 500);
                      }}
                      value={[this.state.min_amount, this.state.max_amount]}
                      min={0}
                      max={this.state.maxAr}
                    />
                  </Col>
                </Col>
              </Row>
              <hr style={{ border: "1px solid #B7B7B7", marginBottom: 40 }} />
            </>
          )}

          <Col xs={24} style={{ marginBottom: 15, marginTop: 20 }}>
            <Card>
              <Row gutter={[16, 16]} justify="space-around">
                <DateBasedCardData label="(0-29 Days)" data={this.state.cardData.total_0_30} />
                <DateBasedCardData label="(30-59 Days)" data={this.state.cardData.total_31_60} />
                <DateBasedCardData label="(60-89 Days)" data={this.state.cardData.total_61_90} />
                <DateBasedCardData label="(+90 Days)" data={this.state.cardData.total_greater_than_90} />
              </Row>
            </Card>
          </Col>
          {this.state.loading ? (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: 100 }}>
              <Spin size="large" />
            </div>
          ) : (
            <div className="requests">
              <br />
              <Table
                style={{ borderRadius: 8, boxShadow: " 0px 0px 10px 0px rgba(0, 0, 0, 0.15)", cursor: "pointer" }}
                columns={columns}
                dataSource={this.state.ARList}
                onRow={(record, rowIndex) => {
                  return {
                    onClick: (event) => {
                      localStorage.setItem("totalAmount.id", eval(record.total_amount.split("$")[1].replace(",", "")));
                      localStorage.setItem("guarantor.id", record.guarantor.id);
                      localStorage.setItem("pat_id", record.patient ? record.patient.id : "");
                      localStorage.setItem("pat_name", record.patient ? record.patient.first_name + " " + record.patient.last_name : "");
                      this.setState({ selectedAR: record.id });
                      this.props.history.push("/#/ar-detail/" + record.guarantor.firstname + "-" + record.guarantor.lastname + "/?id=" + record.id);
                    },
                  };
                }}
                pagination={false}
              />
              <Row type="flex" justify="center" className="ar_mt15">
                <Pagination
                  disabled={this.state.loading}
                  current={this.state.currentPage}
                  total={this.state.page_size}
                  onChange={this.handlePageChange}
                  className="paginator"
                  size="large"
                />
              </Row>
            </div>
          )}
        </div>
      </DashboardLayout>
    );
  }
}

function DateBasedCardData({ label, data }) {
  return (
    <Col xs={24} sm={24} md={12} lg={6}>
      <div
        style={{
          height: 108,
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          background: "rgba(223, 218, 255, 0.7)",
          borderRadius: "8px",
        }}
      >
        <div className="circle" style={{ marginLeft: 15 }}>
          <img className="icon-center" src={card} alt="" />
        </div>
        <div style={{ marginLeft: 20 }}>
          <div style={{ fontSize: 20, fontWeight: 400, color: "#4D3280", marginBottom: 5 }}>
            AR <span style={{ fontSize: 16, color: "#5D3B9C" }}>{label}</span>
          </div>
          <div style={{ fontSize: 24, color: "#5D3B9C", fontWeight: 700 }}>${data}</div>
        </div>
      </div>
    </Col>
  );
}

function mapStateToProps(state) {
  const { loadingSummary, summary, profileSummary, loadingRequests, requests, error } = state.dashboard;
  return {
    loadingSummary,
    summary,
    profileSummary,
    loadingRequests,
    requests,
    error,
    authentication: state.authentication,
  };
}

const connectedAR = connect(mapStateToProps)(AR);

export default withRouter(connectedAR);
